import React from 'react';

import PropTypes from 'prop-types';
import { Button, Form, Input } from 'semantic-ui-react';

import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';

import withCopyToClipboard from 'components/common/CopyToClipboard';
import { createQueryParams } from 'components/modules/files/services/gumlet';
import { Icon } from 'components/modules/foundation/components';

import { DESKTOP_DEVICE } from '../../ImageQueryParamBuilder.constants';
import { ImageQueryParamBuilderFormDataPropType } from '../../ImageQueryParamBuilder.types';

import './QueryParamsDisplay.scss';

const propTypes = {
  formData: ImageQueryParamBuilderFormDataPropType.isRequired,
  url: PropTypes.string,
};

const defaultProps = {
  url: '',
};

const CopyToClipboard = withCopyToClipboard(Button);

export default function QueryParamsDisplay({ formData, url }) {
  const activeDevice = DESKTOP_DEVICE;

  const activeFormData = _get(formData, activeDevice, {});
  const queryParams = createQueryParams(activeFormData) || '';

  const fullUrl = `${url}${queryParams}`;

  function onOpenInNewTab() {
    window.open(fullUrl, '_blank');
  }

  const disableButtons = _isEmpty(queryParams) || _isEmpty(url);

  return (
    <>
      <Form.Input label="Current Query Params" className="query-params-display">
        <Input value={queryParams} />
        <CopyToClipboard icon value={queryParams} disabled={disableButtons}>
          <Icon name="copy" />
        </CopyToClipboard>
        {!_isEmpty(url) && (
          <Button icon="external alternate" onClick={onOpenInNewTab} disabled={disableButtons} />
        )}
      </Form.Input>
    </>
  );
}

QueryParamsDisplay.propTypes = propTypes;
QueryParamsDisplay.defaultProps = defaultProps;
